<template>
    <b-form-row>
        <b-modal size="xl" button-size="sm" :id="this.id" ref="finder" hide-footer :title="prefix + title"
            @hidden="cancelar" @close="cancelar">            
            <ClasseList :apenasConsumo="apenasConsumo" @onDblClickClasse="classeSelect" :prefix="prefix" :addBtnVisible="false" />
        </b-modal>

        <lg-form-input-finder v-model="localValue" fieldDescription="descricao" :label="label"
            invalidFeedback="Classe deve ser informada!" description="" @handleClean="classeSelect">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed v-if="user !== null">
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import ClasseList from "@/modules/cadastros/classe/ClasseList.vue"

export default {
    components: { LgFormInputFinder, ClasseList },

    props: {

        apenasConsumo: { type: Boolean, default: null },
        id: String,
        value: Object,
        user: Object,
        prefix: {
            type: [String, Array],
            default: "",
        },
        title: {
            type: [String, Array],
            default: "Classe",
        },

        label: {
            type: String,
            default: "Classe:",
        },
    },

    data() {
        return {
            descricao: "",
            localValue: this.value,
        }
    },
    computed: {
    },
    watch: {
        value(newValue) {
            this.localValue = newValue
        },

        localValue(newValue) {
            this.$emit("input", newValue)
        },
    },

    methods: {
        async show() {
            await this.$refs.finder.show()
            this.$bvModal.show(this.id)
        },

        cancelar() {
            this.$emit("close")
        },

        async classeSelect(classe) {
            this.$emit("onselect", classe)
            await this.$bvModal.hide(this.id)
        },
    },
}
</script>
